export const STORE_KEY = 'currency';
